import {bool, mixed, number, object, ref, setLocale, string, addMethod} from "yup";

addMethod(mixed, 'nullToEmptyString', function () {
    return this.transform((value) => (value === null ? '' : value));
});
addMethod(string, 'nullToEmptyString', function () {
  return this.transform((value) => (value === null ? '' : value));
});

const id = mixed().nullable().notRequired().nullToEmptyString().default('');
const related = object().nullable(true).notRequired().default(null);
const type = mixed().required().nullable().default(1);

setLocale({
  mixed: {
    default: 'Neplatný údaj',
    required: 'Povinný údaj',
  },
  string: {
    email: 'Zadajte platnú emailovú adresu',
    min: 'Príliš krátky údaj. Minimálny počet znakov je ${min}',
  },
  number: {
    min: 'Minimálny vstup je ${min}',
  },
});



export const loginRequestSchema = object({
  login: string().required().min(4, ).default(''),
  password: string().required().min(4, ).default(''),
});
export const forgotPasswordRequestSchema = object({
  login: string().required().min(4, ).default(''),
});
export const resetPasswordRequestSchema = object({
  password: string().required().min(4, ).default(''),
  password_confirmation: string().oneOf([ref('password'), null], 'Heslá sa musia zhodovať').default(''),
});

export const userGroupRequestSchema = object({
  title: string().required().min(4, ).default(''),
});

export const contactRequestSchema = object({
  id: id,
  title: string().notRequired().nullable().default(''),
  description: string().notRequired().nullable().default(''),
  contact: string().required().default(''),
  type: type,
  ord: number().notRequired().nullable().default(10),
  contactable_id: id,
  contactable_type: string().notRequired().nullable().default(''),
});

export const attachmentRequestSchema = object({
  id: id,
  title: string().notRequired().nullable().default(''),
  description: string().notRequired().nullable().default(''),
  type: type,
  attachable_id: id,
  attachable_type: string().notRequired().nullable().default(''),
});

export const newAttachmentsRequestSchema = object({
  files: mixed().default([]),
  filesData: mixed().default([]),
});

export const bankAccountRequestSchema = object({
  id: id,
  title: string().notRequired().nullable().default(''),
  description: string().notRequired().nullable().default(''),
  IBAN: string().required().default(''),
  SWIFT: string().required().default(''),
  bank: string().required().default(''),
  user_id: id,
  ord: number().notRequired().nullable().default(10),
});

export const countryRequestSchema = object({
  id: id,
  title: string().required().min(3, ).default(''),
  code: string().required().min(2, ).default(''),
});

export const addressRequestSchema = object({
  id: id,
  type: type,
  title: string().notRequired().nullable().default(''),
  description: string().notRequired().nullable().default(''),
  street: string().notRequired().nullable().default(''),
  street_number: string().notRequired().nullable().default(''),
  street_plan_number: string().notRequired().nullable().default(''),
  zip: string().notRequired().nullable().default(''),
  city: string().notRequired().nullable().default(''),
  country_id: id,
  country: related,
  ord: number().notRequired().nullable().default(10),
  addressable_id: id,
  addressable_type: string().notRequired().nullable().default(''),
  lat: number().notRequired().nullable().default(null),
  lon: number().notRequired().nullable().default(null),
});

export const representativeRequestSchema = object({
  id: id,
  first_name: string().required().min(2, ).default(''),
  last_name: string().required().min(2, ).default(''),
  title_before: string().notRequired().nullable().default(''),
  title_after: string().notRequired().nullable().default(''),
  birth_at: string().notRequired().nullable().default(null),
  birth_number: string().notRequired().nullable().default(null),
});

export const userRepresentativeRequestSchema = object({
  id: id,
  representative_id: id,
  representative: related,
  user_id: id,
  user: related,
  link_type: type,
  mandate_type: type,
  scope: string().notRequired().nullable().default(null),
  is_temporary: bool().default(false),
  starts_at: string().notRequired().nullable().default(null),
  ends_at: string().notRequired().nullable().default(null),
  procedure: string().notRequired().nullable().default(null),
  share: number().notRequired().nullable().default(null),
  ord: number().notRequired().nullable().default(10),
});

export const userProfileRequestSchema = object({
  id: id,
  first_name: string().notRequired().nullable().default(''),
  last_name: string().notRequired().nullable().default(''),
  title_before: string().notRequired().nullable().default(''),
  title_after: string().notRequired().nullable().default(''),
  birth_at: string().notRequired().nullable().default(null),
  birth_number: string().notRequired().nullable().default(null),
  company: string().notRequired().default(null),
  position: string().notRequired().default(null),
  company_number: string().notRequired().default(null),
  dph_id: string().notRequired().default(null),
  tax_id: string().notRequired().default(null),
  company_registration: string().notRequired().default(null),

  login: string().required().min(4, ).default(''),
  password: string().notRequired().default(''),
  password_confirmation: string().oneOf([ref('password'), null], 'Heslá sa musia zhodovať').default(''),
  nationality: string().notRequired().nullable().default(''),
  locale: string().required().default('sk'),
  timezone: string().required().default('Europe/Bratislava'),
});

export const userRequestSchema = object({
  id: id,
  type: type,
  first_name: string().notRequired().nullable().default(''),
  last_name: string().notRequired().nullable().default(''),
  title_before: string().notRequired().nullable().default(''),
  title_after: string().notRequired().nullable().default(''),
  birth_at: string().notRequired().nullable().default(null),
  birth_number: string().notRequired().nullable().default(null),
  company: string().notRequired().default(null),
  position: string().notRequired().default(null),
  company_number: string().notRequired().default(null),
  dph_id: string().notRequired().default(null),
  tax_id: string().notRequired().default(null),
  company_registration: string().notRequired().default(null),

  new_role_id: id,
  files: mixed().default([]),
  filesData: mixed().default([]),

  login: string().required().min(4, ).default(''),
  password: string().when('id', {is: null, then: (schema)=>schema.required(), otherwise: (schema)=>schema.notRequired()}).default(''),
  password_confirmation: string().oneOf([ref('password'), null], 'Heslá sa musia zhodovať').default(''),
  nationality: string().notRequired().nullable().default(null),
  locale: string().required().default('sk'),
  timezone: string().required().default('Europe/Bratislava'),
});

export const roleRequestSchema = object({
  id: id,
  name: string().required().min(2, ).default(''),
  title: string().required().min(2, ).default(''),
  locked: bool().required().default(false),
  type: number().required().default(1),
});

export const userUserGroupRoleRequest = object({
  id: id,
  role_id: id,
  role: related,
  user_id: id,
  user: related,
  user_group_id: id,
  userGroup: related,
});

export const managerRequestSchema = object({
  id: id,
  first_name: string().required().min(2, ).default(''),
  last_name: string().required().min(2, ).default(''),
  title_before: string().notRequired().nullable().default(''),
  title_after: string().notRequired().nullable().default(''),
  position: string().notRequired().nullable().default(''),
  description: string().notRequired().nullable().default(''),
  is_membership: bool().default(false),
});

export const buildingRequestSchema = object({
  id: id,
  title: string().required().min(2, ).default(''),
  ownership_type: type,
  accounting_period_type: type,
  description: string().notRequired().nullable().default(''),
  last_stats: object().notRequired().nullable()
});

export const buildingStatRequestSchema = object({
  id: id,
  building_id: id,
  quarter: id,
  year: id,
  type: type,
  stat: string().required().default(''),
  date_at: string().required().min(2, ).default(''),
});

export const buildingStatTypeRequestSchema = object({
  id: id,
  sync_id: id,
  title: string().required().default(''),
  metric: string().nullable().notRequired().default(''),
});

export const buildingManagerRequestSchema = object({
  id: id,
  manager_id: id,
  building_id: id,
});

export const articleRequestSchema = object({
  id: id,
  title: string().required().min(2, ).default(''),
  article: string().default(''),
  short_text: string().notRequired().nullable().nullToEmptyString().default(''),
  is_published: bool().default(false),
  published_from: string().notRequired().nullable().default(null),
  published_to: string().notRequired().nullable().default(null),
  building_id: id,
});

export const buildingStatSyncRequestSchema = object({
  building_id: id,
  description: string().notRequired().nullable().default(''),
});

export const attachmentCategoryRequestSchema = object({
  id: id,
  title: string().required().default(''),
  description: string().notRequired().nullable().default(''),
  icon: string().notRequired().nullable().default(''),
  color: string().notRequired().nullable().default(''),
});

export const internalValueRequestSchema = object({
  id: id,
  value_at: string().required().default(''),
  value: mixed().required().default(''),
});

export const transactionRequestSchema = object({
  id: id,
  user_id: id,
  type: type,
  value_at: string().required().default(''),
  value: mixed().required().default(''),
});
